class SoundService {
  private static instance: SoundService;
  private ringtone: HTMLAudioElement;
  private dialTone: HTMLAudioElement;
  private beep: HTMLAudioElement;
  private isRinging: boolean = false;

  private constructor() {
    this.ringtone = new Audio('/sounds/ringtone.mp3');
    this.dialTone = new Audio('/sounds/dial.mp3');
    this.beep = new Audio('/sounds/beep.mp3');

    // Configure ringtone for looping
    this.ringtone.loop = true;
  }

  public static getInstance(): SoundService {
    if (!SoundService.instance) {
      SoundService.instance = new SoundService();
    }
    return SoundService.instance;
  }

  public playRingtone() {
    if (!this.isRinging) {
      this.isRinging = true;
      this.ringtone.play().catch(console.error);
    }
  }

  public stopRingtone() {
    if (this.isRinging) {
      this.isRinging = false;
      this.ringtone.pause();
      this.ringtone.currentTime = 0;
    }
  }

  public playDialTone() {
    this.dialTone.play().catch(console.error);
  }

  public stopDialTone() {
    this.dialTone.pause();
    this.dialTone.currentTime = 0;
  }

  public playBeep() {
    this.beep.play().catch(console.error);
  }

  public stopAll() {
    this.stopRingtone();
    this.stopDialTone();
    this.beep.pause();
    this.beep.currentTime = 0;
  }
}

export default SoundService; 